import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { VSkeletonLoader } from 'vuetify/components'

import { pt } from 'vuetify/locale'

const customTheme = {
  dark: true,
  colors: {
    background: "#14181c",
    surface: "#1E2A32",
    primary: "#00c030",
    secondary: "#1f5c6b",
    accent: "#FFE18F",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107",
    "app-bar": "#0E343E",
    "logo-color": "#FEF3C7E6",
    "card-background": "#1E2A32",
    "match-card": "#1f2937",
    "cream-color": "#FEF3C7",
  },
}

export default createVuetify({
  components: {
    ...components,
    VSkeletonLoader,
  },
  directives,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: { mdi },
  },
  theme: {
    defaultTheme: "customTheme",
    themes: { customTheme },
  },
  // ② configure aqui o locale
  locale: {
    defaultLocale: 'pt',   // define o idioma padrão como Português
    messages: { pt },      // registra as traduções
  },
  defaults: {
    global: {
      style: {
         fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
      },
    },
  },
})
